<template>
  <div
    class="tender-offer-version-dropdown-element spacex-4"
    :class="{ 'tender-offer-version-dropdown-element_muted': muted }"
  >
    <Badge color="dark-grey">{{ $t('v') }}{{ version.name }}</Badge>
    <Badge :color="OFFER_STATUS_BADGE[version.status]">
      {{ tenderOfferVersionStatuses[version.status] }}
    </Badge>
    <span class="grey-500">{{ prettyDates(version.created_at, false, false) }}</span>
  </div>
</template>

<script>
  import prettyDates from '@/utils/formatting/pretty-date';
  import withCurrency from '@/utils/formatting/with-currency';
  import addSpaces from '@/utils/formatting/add-spaces';
  import parseFl from '@/utils/formatting/parse-float';
  import Badge from '@/components/ui/Badge';
  import OFFER_STATUS_BADGE from '@/utils/constants/offer-status-badge';
  import { mapState } from 'vuex';

  export default {
    name: 'TenderOfferVersionDropdownInfo',
    components: {
      Badge,
    },
    props: {
      version: {
        type: Object,
        required: true,
      },
      muted: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        OFFER_STATUS_BADGE,
      };
    },
    computed: {
      ...mapState('global', ['tenderOfferVersionStatuses']),
    },
    methods: {
      prettyDates,
      priceWithCurrency(price) {
        return withCurrency(addSpaces(parseFl(price), true), { zeros: true });
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .tender-offer-version-dropdown-element {
    display: flex;
    flex: 1;
    flex-direction: row;
    &_muted {
      cursor: not-allowed;
      ::v-deep .badge {
        background-color: $grey200;
        color: $grey400;
      }
    }
  }
</style>
